import { createSelector } from 'reselect';

const getLeaseFilter = (state) => state.leaseFilter;

export const leaseOptions = createSelector(
  [getLeaseFilter], (leaseFilter) => {
    let options = [];

    if (leaseFilter) {
      options = leaseFilter;
    }

    return { leaseOptions: options };
  },
);

export const selectedLeaseOption = createSelector(
  [getLeaseFilter], (leaseFilter) => {
    let leaseOption = [];

    if (leaseFilter) {
      leaseOption = leaseFilter.filter((option) => option.selected === true);
    }

    return leaseOption[0];
  },
);
